import React from "react";

interface AppointmentFilterProps {
  selectedOption: string;
  handleDay: (event: React.ChangeEvent<HTMLInputElement>) => void;
  all: string;
  handleOptionChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const statusFilters = [
  { value: "pending", label: "Appointments", color: "indigo" },
  { value: "inqueue", label: "In Queue", color: "sky" },
  { value: "appointment", label: "Upcoming", color: "orange" },
  { value: "completed", label: "Completed", color: "emerald" },
  { value: "canceled", label: "Cancelled", color: "red" },
  { value: "ongoing", label: "Ongoing", color: "lime" },
  { value: "noshow", label: "No Show", color: "slate" },
];

const AppointmentFilter: React.FC<AppointmentFilterProps> = ({
  selectedOption,
  handleDay,
  all,
  handleOptionChange,
}) => {
  return (
    <div className="space-y-4 mb-6">
      {/* Day Selection */}
      <div className="flex items-center gap-2">
        <span className="text-sm font-medium text-slate-500">Period:</span>
        <div className="flex gap-1 p-1 bg-slate-100 rounded-lg">
          {["today", "all"].map((day) => (
            <label
              key={day}
              className={`px-4 py-1.5 rounded-md text-sm font-medium cursor-pointer transition-all ${
                all === day
                  ? "bg-white text-indigo-600 shadow-sm"
                  : "text-slate-500 hover:text-slate-700"
              }`}
            >
              <input
                type="radio"
                name="day"
                value={day}
                onChange={handleDay}
                checked={all === day}
                className="sr-only"
              />
              {day.charAt(0).toUpperCase() + day.slice(1)}
            </label>
          ))}
        </div>
      </div>

      {/* Status Filters */}
      <div className="flex flex-wrap gap-2">
        {statusFilters.map(({ value, label }) => (
          <label
            key={value}
            className={`px-3 py-1.5 rounded-lg text-sm font-medium cursor-pointer transition-all border ${
              selectedOption === value
                ? "bg-indigo-500 text-white border-indigo-500 shadow-md"
                : "bg-white text-slate-600 border-slate-200 hover:border-indigo-300 hover:text-indigo-600"
            }`}
          >
            <input
              type="radio"
              value={value}
              checked={selectedOption === value}
              onChange={handleOptionChange}
              className="sr-only"
            />
            {label}
          </label>
        ))}
      </div>
    </div>
  );
};

export default React.memo(AppointmentFilter);
